import script from "./chartOfAccount.vue?vue&type=script&setup=true&lang=js"
export * from "./chartOfAccount.vue?vue&type=script&setup=true&lang=js"

import "./chartOfAccount.vue?vue&type=style&index=0&id=32d2e539&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32d2e539"]])

export default __exports__